module.exports = __webpack_public_path__ + "static/media/login_background_image.91f73c43.png";